import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ToasterContainer } from 'baseui/toast';
import AdminPage from './components/admin';
import { AuthCheck } from './auth-check';
import ImageStudioWithQuestionnaire from './image-studio-with-questionnaire';
import { PreviewPage } from './preview-page';
const getComponent = () => {
  const {
    pathname
  } = window.location;
  if (pathname.startsWith('/admin')) {
    return <AdminPage />;
  } else if (pathname.endsWith('preview')) {
    return <PreviewPage />;
  } else {
    return <ImageStudioWithQuestionnaire />;
  }
};
export const ULabelLite = () => {
  return <QueryClientProvider client={new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false
      }
    }
  })}>
      <ToasterContainer />
      <AuthCheck>{getComponent()}</AuthCheck>
    </QueryClientProvider>;
};